import { NavLink as Link } from "react-router-dom";
import styled from 'styled-components';

export const Nav = styled.nav`
    background: #7A003C;
    height: 45px;
    display: flex;
    position: sticky;
    width: 100vw;
    justify-content: center;
    align-items: center;
    z-index: 12;
    border-bottom: 2px solid #FDBF57;
    text-align: center;
    top: 0;
`;

export const NavLink = styled(Link)`
    color: #FFFFFF;
    font-size: 1rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem 2px;
    height: 111%;
    text-align: center;
    cursor: pointer;
    &.active {
        text-decoration: underline;
        text-underline-offset: 6px;
        text-decoration-thickness: 3px;
        text-decoration-color: #FFFFFF;
    }
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #FFFFFF;
        color: #000000;
        box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.2); 
    }
`;

export const NavMenu = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    text-align: center;

    @media(max-width: 767px){
        display: none;
    }
`;


export const HamburgerMenu = styled.div`
    display: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 10px;
    user-select: none;
    transition: transform 0.2s ease;
    @media (max-width: 767px){
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &:hover {
        transform: scale(1.1);
    }
    &:active {
        transform: scale(0.95);
    }
`;

export const Dropdown = styled.div`
    background: #7A003C;
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 100%;
    left: 0;
    top: 115px; /* Header (70px) + Navbar (45px) */
    z-index: 999;
    padding: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-height: calc(100vh - 115px);
    overflow-y: auto;
`

export const Overlay = styled.div`
    display: none;
    @media (max-width: 767px) {
        display: block;
        position: fixed;
        top: 115px;
        left: 0;
        width: 100%;
        height: calc(100vh - 115px);
        background: rgba(0, 0, 0, 0.5);
        z-index: 998;
    }
`

export const LogoutButton = styled.div`
    color: #FDBF57;
    font-size: 1rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem 2px;
    height: 111%;
    text-align: center;
    cursor: pointer;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-style: normal;
    border-left: 2px solid #FDBF57;
    margin-left: 1rem;
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #FDBF57;
        color: #7A003C;
        box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.2);
    }
`